module.exports = __webpack_public_path__ + "h5/img/global_yg.30f93847.png";